export default {
	data() {
		return {
			filterModel: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterModel._id": {
			handler(val) {
				let fieldName = "model";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
